import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  toastOptions = {
    isShowing : false,
    toastTime : 5000
  }

  showToast(): void {
    this.toastOptions.isShowing = true;
  }

  closingToast(): void{
    this.toastOptions.isShowing = false;
  }
}
